import { createContext } from "react";
import { RecommendationAzure } from "../../types/types";

export const RecommendationSummaryPanelContext = createContext<
  ((rec: RecommendationAzure) => void) | null
>(null);
